import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import posthog from "posthog-js";
import App from "./App";
import "./App.css";

import RootComponent from "./root";

// Initialize PostHog — manual capture only (A/B test events)
if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    rageclick: false,
    enable_heatmaps: false,
  });
}

const root = createRoot(document.getElementById("root"));
root.render(
  <RootComponent />
);
